const toBool = (value) => {
	return value === 'true' || (value !== 'false' && value) || false
}
export default toBool
